module.exports = san.defineComponent({
    template: require('../views/homeHeader.html'),
    initData: function() {
        return {
            title:'',
            subTitle:''
        };
    },
    components: {

    },
    created: function() {

    },
    back: function(){
        this.dispatch('back');
    },
    setTitle: function(title,subTitle) {
        this.data.set('title',title);
        this.data.set('subTitle',subTitle);
    },
    messages:{

    }
});


//////////////////
// WEBPACK FOOTER
// ./src/components/header.js
// module id = 356
// module chunks = 1